/**
 * isiZulu: Files
 *
 * What this file covers: Uploading files and previewing them (documents, images, audio, video).
 *
 * Tone: Short functional labels, like a file manager.
 *
 * isiZulu: Everyday isiZulu as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const files: Catalog = {
  'upload.prompt': 'Yehlisa ifayela lapha, noma chofoza ukuze uphequlule',
  'upload.library': 'Khetha kwilabhulali',
  'upload.library.title': 'Ilabhulali yemidiya',
  'upload.library.search': 'Sesha ngegama lefayela',
  'upload.library.empty': 'Alukho lutho okwamanje. Layisha ifayela ukuze ulibone lapha.',
  'upload.library.more': 'Layisha okuningi',
  'upload.uploading': 'Iyalayisha',
  'upload.replace': 'Shintsha',
  'upload.rename': 'Qamba kabusha',
  'upload.rename.title': 'Qamba ifayela kabusha',
  'upload.rename.placeholder': 'Igama lefayela',
  'upload.copy': 'Kopisha isixhumanisi',
  'upload.copied': 'Kukopishiwe',
  'upload.select': 'Khetha',
  'upload.delete': 'Susa unomphela',
  'upload.delete.confirm': 'Susa leli fayela kubo bonke? Noma yini esalisebenzisa izophuka.',
  'upload.filter.all': 'Konke',
  'upload.filter.image': 'Izithombe',
  'upload.filter.video': 'Ividiyo',
  'upload.filter.document': 'Amadokhumenti',
  'upload.error.tooLarge': 'Lelo fayela likhulu kakhulu.',
  'upload.error.type': 'Lolo hlobo lwefayela alwamukelwa.',
  'upload.error.infected': 'Lelo fayela lihlulekile ekuskeneni kwegciwane futhi aligcinwanga.',
  'upload.error.scanUnavailable': 'Isiskeni segciwane asifinyeleleki. Zama futhi maduze.',
  'upload.error.notConfigured': 'Isitoreji sefayela asilungiselelwe. Umqhubi kufanele asisethe ngaphansi kwezilungiselelo, Ukuhlanganiswa.',
  'upload.error.generic': 'Ukulayisha kuhlulekile.'
};

export default files;
